<template>
  <div
    v-if="show"
    class="k__cookie-popup"
    :style="styles"
  > 
    <p class="tips">
      This webpage uses cookies to improve your online user experience. To find out more, see our
      <a href="/help-center/oh_3698?s_id=1004&bs_type=1&c_id=1083" target="_blank">Cookie Policy</a>.
    </p>

    <div class="next">
      <van-button size="small" class="next-btn" type="primary" @click="handleNextClick">Next</van-button>
    </div>
  </div>
</template>

<script setup lang="ts">
const { $formatDate } = useNuxtApp()
const pcStyle = {
  textAlign: 'center',
  padding: '20px'
}
const wapStyle = {
}
const styles = computed(() => useIsMobile().value ? wapStyle : pcStyle)
const show = ref<boolean>(false)
const curYM = $formatDate(new Date(), 'yyyy-MM')
watch(
  () => show.value,
  (val: boolean) => {
    if(!val) {
      localStorage.setItem('use-cookie', curYM)
    }
  }
)
const handleNextClick = () => {
  show.value = false
}

onMounted(() => {
  const lastYM = localStorage.getItem('use-cookie')

  if(!lastYM || curYM !== lastYM) {
    show.value = true
  }

  document.addEventListener('click', handleNextClick, { once: true })
})
</script>

<style lang="scss" scoped>
.k__cookie-popup{
  padding: 10px 60px;
  font-size: 32px;
  background-color: #fff;
  line-height: 30px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  box-shadow: 0 0 8px #cacaca;
}
.next{
  margin-top: 20px;
  text-align: center;
}

.next-btn{
  width: 300px;
}
a{
  color: blue;
  border-bottom: 1px solid blue;
}
</style>